import $i18n from "@/language";
import { authenticateJWT, handleExceptionMsg, i18nNameFormatting } from "@/libs/common";
import { authenticateToken } from "./authentication";
import * as message from "@/plugins/message";
import constants from "@/libs/constants";
import router from "@/router/index.js";
import { parseJWT, defaultOctopusObj } from "../common";
import applicationAPI from "@/http/apis/personal/application";
import { usePersonalStore } from "../../store/personal";

let i18n = $i18n.global;

export function defaultOctopusExtensionObj() {
  return {
    expiry: null,
    isRequired: false
  }
}

export async function handlePersonalSessionExpired() {
  const personalStore = usePersonalStore();
  
  message.ConfirmDialog(
    i18n.t("personal.dialog.sessionExpired.title"),
    i18n.t("personal.dialog.sessionExpired.message"),
    async () => {
      let token = parseJWT(personalStore.jwt).token;
      let res = await authenticateToken(token,false);
      if (!res) {
        personalStore.resetPersonalState(false);
        router.push({ name: "StepStart", params: { locale: i18n.locale } });
        return;
      }
      if (personalStore.form.type == "R") {
        window.location.reload();
      } else {
        if (personalStore.form.authen) {
          handleAuthen();
        }
      }
    },
    () => {
      personalStore.resetPersonalState(false);
      router.push({ name: "StepStart", params: { locale: i18n.locale } });
    },
    () => {},
    {
      showClose: false
    }
  );
}

export async function handlePersonalException(source, noAlert) {
  let msg;
  if (!source.response) {
    msg = i18n.t("exceptions.default");
  } else {
    if (Object.prototype.hasOwnProperty.call(source.response.data, "ErrorCode")) {
      msg = source.response.data.Message[i18n.locale.charAt(0).toUpperCase() + i18n.locale.slice(1)];
      let code = source.response.data.ErrorCode;
      switch (code) {
        case "MAINTENANCE":
          noAlert = true;
          window.location.href = constants.links.common.maintenance;
          break;
        case "COMPLETED_TOKEN":
        case "EXPIRED_TOKEN":
        case "INACTIVE_TOKEN":
          noAlert = true;
          router.push({ name: "PersonalForbidden", params: { locale: i18n.locale }, query: { type: code.substring(0, 1) } });
          break;
        case "TOKEN_INVALID":
          noAlert = true;
          router.push({ name: "PersonalUnauthorized", params: { locale: i18n.locale } });
          break;
      }
    } else {
      msg = i18n.t("exceptions.default");
      switch (source.response.status) {
        case 500:
          handleAuthen();
          break;
        case 401: {
          if (!authenticateJWT(usePersonalStore().jwt)) {
            noAlert = true;
            handlePersonalSessionExpired();
          }
          break;
        }
      }
    }
  }
  return handleExceptionMsg(noAlert, msg, source);
}

export function checkType(source, type) {
  let sourceType = null;
  const personalStore = usePersonalStore();
  
  switch(source) {
    case "identity":
      sourceType = personalStore.form.identity.type
      break;
    case "appType":
      sourceType = personalStore.form.applicationType.type
      break;
  }
  let result = sourceType == type;
  if (Array.isArray(type)) {
    result = type.some((val) => sourceType == val);
  }
  return result;
}

export function defaultRenewInfoObj(){
  return {
    name: null,
    mobile: null,
    octopus: defaultOctopusObj()
  }
}

export async function validateFile(dataUrl, fileCategory, label) {
  try {
    let jwt = usePersonalStore().jwt;
    let formData = createFileFormData(dataUrl, fileCategory);
    let fileValidateRes = await applicationAPI.postFormFileValidate(jwt, formData)  
    let res = fileValidateRes.status == 200;
    return res;
  } catch(err) {
    console.log(err)
    if (err.status == 400) {
      let paramObj = {
        field: label
      }
      message.WarningAlert(i18nNameFormatting("exceptions.invalidFile", paramObj));
    } else {
      handlePersonalException(err)
    }
    
    return false;
  }
}

export function createFileFormData(dataUrl, fileCategory) {
  let binaryData = atob(dataUrl.split(',')[1]);
  let uint8Array = new Uint8Array(binaryData.length);
  for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
  }

  let mimeType = dataUrl.split(';')[0].split(':')[1];
  let blob = new Blob([uint8Array], { type: mimeType});

  let formData = new FormData();
  formData.append('File', blob, `file.${mimeType === "application/pdf" ? "pdf" : "jpeg"}`);
  formData.append('FolderType', fileCategory);
  
  return formData;
}

function handleAuthen() {
  const personalStore = usePersonalStore();
  let form = personalStore.form;
  if (form.authen) {
    if (!form.id) {
      personalStore.resetAuthen();
      if (router.currentRoute.value.name == "StepForm") {
        window.location.reload();
      } else {
        router.push({ name: "StepForm", params: {locale: i18n.locale} });
      }
    }
  }
}